import { render, staticRenderFns } from "./SickLeaveWithQualifyingDeductionCalculation.vue?vue&type=template&id=6253ca10"
import script from "./SickLeaveWithQualifyingDeductionCalculation.vue?vue&type=script&lang=js"
export * from "./SickLeaveWithQualifyingDeductionCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports